import { DATA_TA } from "./dataTa";

/** Tamil (ta) and English (en) are edited separately — do not change en when updating ta unless asked. */

export const UI = {
  en: {
    searchPlaceholder: "What do you want to pay?",
    clear: "Clear",
    skipToMain: "Skip to main content",
    homeBrand: "IndiaFees home",
    opensNewTab: "opens in new tab",
    home: "Home",
    trustBadge: "Official portals only — we never collect money",
    heroTitle: "All Tamil Nadu government payments",
    heroDesc: "Official Tamil Nadu government payment links — electricity, tax, water, fees & challans. We never collect money.",
    shareLabel: "Share this page",
    shareWhatsApp: "Share this page on WhatsApp",
    shareWhatsAppCard: "WhatsApp",
    shareCopy: "Copy link",
    shareCopied: "Copied!",
    shareMore: "Share",
    shareSiteText: "Pay TN electricity, property tax, water bill & 130+ govt fees — official links only 👇",
    viralBannerTitle: "Know someone paying TN bills?",
    viralBannerBody: "Forward IndiaFees on WhatsApp — free official links, no app download.",
    viralBannerBtn: "Share on WhatsApp",
    viralBannerMsg: "🇮🇳 Tamil Nadu govt payments — one link for everything!\n\n⚡ TNEB electricity\n🏠 Property tax\n💧 Water bill\n🚗 Challan & 130+ more\n\n✅ Official portals only — FREE",
    shareMsgGuide: (name) => `How to pay ${name} online in Tamil Nadu — step-by-step + official portal link 👇`,
    shareMsgDept: (name) => `${name} — all official TN payment links in one place 👇`,
    shareMsgQuick: (label) => `Pay ${label} online in Tamil Nadu — official link + guide on IndiaFees 👇`,
    seasonTitle: "Property tax reminder",
    seasonMar: "Property tax due Mar 31 — share the official payment link with family & neighbours.",
    seasonApr: "Pay property tax by Apr 30 for 5% early discount — official GCC / TN Urban ePay links on IndiaFees.",
    seasonSep: "Property tax due Sep 30 — share the official payment link with family & neighbours.",
    seasonShare: "Share guide on WhatsApp",
    quickPay: "Quick pay",
    directPaymentPage: "Direct payment page",
    browseDept: "Browse by department",
    browseDeptSub: (n) => `${n} Tamil Nadu departments with official payment links`,
    paymentLinks: (n) => `${n} payment link${n !== 1 ? "s" : ""}`,
    openPortal: "Open portal",
    results: (n) => `${n} result${n !== 1 ? "s" : ""}`,
    resultsFor: (q) => `For “${q}”`,
    emptySearch: "Nothing found — try “TNEB”, “property”, or “challan”",
    footTrustTitle: "Independent directory — not a government website",
    footTrustBody: "We link only to official government portals. We do not collect payments, store Aadhaar information, or act as an intermediary.",
    footPrivacy: "Privacy Policy",
    footTerms: "Terms of Use",
    footContact: "Contact",
    footDisclaimer: "Disclaimer",
    footHyperlink: "Hyperlinking Policy",
    footGuides: "Payment guides",
    footCopy: (y) => `© ${y} IndiaFees — Tamil Nadu government payments`,
    deptMetaDesc: (deptName, n) => `${deptName} — ${n} official payment link${n !== 1 ? "s" : ""} on IndiaFees.`,
    authLogin: "Log in",
    authSignup: "Sign up",
    authLogout: "Log out",
    authAccount: "My account",
    authEmail: "Email",
    authMobile: "Mobile number",
    authEmailOrMobile: "Email or mobile",
    authMethodEmail: "Email",
    authMethodMobile: "Mobile",
    authSignupWith: "Sign up with",
    authLoginWith: "Log in with",
    authSeparateAccounts: "Mobile and email are separate accounts — sign up with each one separately.",
    authMobileHint: "10-digit Indian mobile (e.g. 9876543210)",
    authPassword: "Password",
    authName: "Full name",
    authForgot: "Forgot password?",
    authCreate: "Create account",
    authHaveAccount: "Already have an account? Log in",
    authPasswordHint: "At least 8 characters",
    authShowPassword: "Show password",
    authHidePassword: "Hide password",
    authSendReset: "Send reset link",
    authSendResetCode: "Send reset code",
    authForgotSentSms: "We sent a 6-digit reset code to your mobile.",
    authResetCode: "6-digit reset code",
    authBackLogin: "Back to log in",
    authReset: "Reset password",
    authNewPassword: "New password",
    authSavePassword: "Save password",
    authInvalidReset: "Invalid or expired reset link.",
    authMemberSince: "Member since",
    authVerify: "Verify account",
    authVerifyCode: "6-digit code",
    authVerifySubmit: "Verify",
    authVerifySent: "We sent a verification code to your email.",
    authVerifySentSms: "We sent a 6-digit OTP to your mobile.",
    authVerifySuccess: "Account verified! You can now log in.",
    authResendCode: "Resend code",
    authResendBusy: "Sending…",
    authVerifyTokenBusy: "Verifying link…",
    authVerifyNeedEmail: "Enter the email you signed up with.",
    authVerifyNeedContact: "Enter the email or mobile you signed up with.",
    guidesTitle: "How to pay — step-by-step guides",
    guidesSub: (n) => `${n} official Tamil Nadu payment guides with direct portal links`,
    guideStepsTitle: "Steps to pay online",
    guideOfficialTitle: "Official payment portal",
    guideOfficialBody: "IndiaFees does not collect money. Click below to open the authorised government website in a new tab.",
    guideFaqTitle: "Common questions",
    guideDisclaimer: "Always verify you are on an official .gov.in or authorised portal before entering payment details.",
    guideLink: "Direct payment link",
    cityTitle: (name) => `${name} payment link`,
    cityCrumb: (name) => `${name} payment link`,
    cityBrowse: "Browse by city",
    cityBrowseSub: "Official payment links for major Tamil Nadu cities",
    quickPayItems: [
      { label: "TNEB bill", sharePath: "/pay/1-electricity-bill-lt-1" },
      { label: "Property tax", sharePath: "/pay/2-tn-urban-municipal-tax-3" },
      { label: "Chennai property", sharePath: "/pay/2-chennai-property-tax-2" },
      { label: "Water bill", sharePath: "/pay/2-chennai-water-tax-1" },
      { label: "Challan", sharePath: "/pay/5-traffic-challan-6" },
      { label: "GST / Tax", sharePath: "/pay/4-gst-tax-payment-5" },
      { label: "Court fee", sharePath: "/pay/12-court-filing-fee-1" },
      { label: "Treasury", sharePath: "/pay/15-treasury-e-challan-karuvoolam-1" },
      { label: "VAT e-pay", sharePath: "/pay/4-vat-e-payment-4" },
      { label: "Prof. tax", sharePath: "/pay/2-municipal-professional-tax-9" },
      { label: "Trade license", sharePath: "/pay/2-trade-license-fee-urban-10" },
      { label: "SBI Collect", sharePath: "/pay/15-treasury-payment-grips-2" },
      { label: "BDU fees", sharePath: "/pay/8-bharathidasan-university-fee-2" },
      { label: "Madras Univ", sharePath: "/pay/8-madras-university-fee-3" },
      { label: "Aavin milk", sharePath: "/pay/26-aavin-milk-card-renewal-1" },
      { label: "FASTag", sharePath: "/pay/20-fastag-recharge-1" },
      { label: "UGD tax", sharePath: "/pay/2-underground-drainage-ugd-tax-11" },
      { label: "SDAT sports", sharePath: "/pay/27-sdat-sports-registration-1" },
    ],
  },
  ta: {
    searchPlaceholder: "என்ன கட்டணம் செலுத்த வேண்டும்?",
    clear: "அழி",
    skipToMain: "முக்கிய உள்ளடக்கத்திற்குச் செல்ல",
    homeBrand: "IndiaFees முகப்பு",
    opensNewTab: "புதிய தாவலில் திறக்கும்",
    home: "முகப்பு",
    trustBadge: "அதிகாரப்பூர்வ தளங்கள் மட்டும் — நாங்கள் பணம் வசூலிக்க மாட்டோம்",
    heroTitle: "தமிழ்நாட்டின் அனைத்து அரசு கட்டணங்கள்",
    heroDesc: "அதிகாரப்பூர்வ தமிழ்நாடு அரசு கட்டண இணைப்புகள் — மின்சாரம், வரி, குடிநீர், கட்டணம், அபராதம். நாங்கள் பணம் வசூலிக்க மாட்டோம்.",
    shareLabel: "பகிர்",
    shareWhatsApp: "இந்த தளத்தை WhatsApp-ல் பகிருங்கள்",
    shareWhatsAppCard: "WhatsApp பகிர்",
    shareCopy: "இணைப்பு நகல்",
    shareCopied: "நகலெடுக்கப்பட்டது!",
    shareMore: "பகிர்",
    shareSiteText: "TNEB, சொத்து வரி, குடிநீர் & 130+ அரசு கட்டண இணைப்புகள் — IndiaFees 👇",
    viralBannerTitle: "நண்பர்கள் / குடும்பத்திற்கு உதவுங்கள்",
    viralBannerBody: "WhatsApp-ல் IndiaFees ஐ பகிருங்கள் — இலவசம், அதிகாரப்பூர்வ இணைப்புகள் மட்டும்.",
    viralBannerBtn: "WhatsApp-ல் பகிர்",
    viralBannerMsg: "🇮🇳 தமிழ்நாடு அரசு கட்டணங்கள் — ஒரே இணைப்பில் அனைத்தும்!\n\n⚡ TNEB மின்சாரம்\n🏠 சொத்து வரி\n💧 குடிநீர்\n🚗 அபராதம் & 130+ இணைப்புகள்\n\n✅ அதிகாரப்பூர்வ தளங்கள் மட்டும் — இலவசம்",
    shareMsgGuide: (name) => `${name} ஆன்லைனில் எப்படி செலுத்துவது — படிப்படியான வழி + அதிகாரப்பூர்வ இணைப்பு 👇`,
    shareMsgDept: (name) => `${name} — அனைத்து அதிகாரப்பூர்வ TN கட்டண இணைப்புகள் ஒரே இடம் 👇`,
    shareMsgQuick: (label) => `${label} ஆன்லைன் செலுத்த — அதிகாரப்பூர்வ இணைப்பு IndiaFees-ல் 👇`,
    seasonTitle: "சொத்து வரி நினைவூட்டல்",
    seasonMar: "மார்ச் 31 வரை சொத்து வரி — குடும்பத்துடன் அதிகாரப்பூர்வ இணைப்பைப் பகிருங்கள்.",
    seasonApr: "ஏப்ரல் 30 வரை செலுத்தினால் 5% தள்ளுபடி — IndiaFees-ல் அதிகாரப்பூர்வ இணைப்பு.",
    seasonSep: "செப்டம்பர் 30 வரை சொத்து வரி — அதிகாரப்பூர்வ இணைப்பைப் பகிருங்கள்.",
    seasonShare: "WhatsApp-ல் பகிர்",
    quickPay: "விரைவு கட்டணம்",
    directPaymentPage: "நேரடி கட்டணப் பக்கம்",
    browseDept: "துறை வாரியாக உலாவுங்கள்",
    browseDeptSub: (n) => `${n} தமிழ்நாடு துறைகள் — அதிகாரப்பூர்வ கட்டண இணைப்புகள்`,
    paymentLinks: (n) => `${n} கட்டண இணைப்பு${n !== 1 ? "கள்" : ""}`,
    openPortal: "தளத்தைத் திறக்க",
    results: (n) => `${n} முடிவு${n !== 1 ? "கள்" : ""}`,
    resultsFor: (q) => `“${q}” க்கான தேடல்`,
    emptySearch: "எதுவும் கிடைக்கவில்லை — “TNEB”, “வரி”, “அபராதம்” என்று முயற்சிக்கவும்",
    footTrustTitle: "அரசு சாராத கட்டண வழிகாட்டி — இது அரசு வலைத்தளம் அல்ல.",
    footTrustBody: "அதிகாரப்பூர்வ அரசு வலைத்தள இணைப்புகள் மட்டும்.",
    footPrivacy: "தனியுரிமைக் கொள்கை",
    footTerms: "பயன்பாட்டு நிபந்தனைகள்",
    footContact: "தொடர்பு",
    footDisclaimer: "பொறுப்புத் துறப்பு",
    footHyperlink: "இணைப்பு கொள்கை",
    footGuides: "கட்டண வழிகாட்டிகள்",
    footCopy: (y) => `© ${y} IndiaFees — தமிழ்நாடு அரசு கட்டணங்கள்`,
    deptMetaDesc: (deptName, n) => `${deptName} — IndiaFees-ல் ${n} அதிகாரப்பூர்வ கட்டண இணைப்பு${n !== 1 ? "கள்" : ""}.`,
    authLogin: "உள்நுழை",
    authSignup: "பதிவு",
    authLogout: "வெளியேறு",
    authAccount: "என் கணக்கு",
    authEmail: "மின்னஞ்சல்",
    authMobile: "கைபேசி எண்",
    authEmailOrMobile: "மின்னஞ்சல் அல்லது கைபேசி",
    authMethodEmail: "மின்னஞ்சல்",
    authMethodMobile: "கைபேசி",
    authSignupWith: "இதன் மூலம் பதிவு",
    authLoginWith: "இதன் மூலம் உள்நுழை",
    authSeparateAccounts: "கைபேசி மற்றும் மின்னஞ்சல் தனித் தனி கணக்குகள் — ஒவ்வொன்றையும் தனியாகப் பதிவு செய்யுங்கள்.",
    authMobileHint: "10 இலக்க இந்திய கைபேசி எண்",
    authPassword: "கடவுச்சொல்",
    authName: "முழு பெயர்",
    authForgot: "கடவுச்சொல் மறந்ததா?",
    authCreate: "கணக்கு உருவாக்கு",
    authHaveAccount: "ஏற்கனவே கணக்கு உள்ளதா? உள்நுழை",
    authPasswordHint: "குறைந்தது 8 எழுத்துகள்",
    authShowPassword: "கடவுச்சொல் காட்டு",
    authHidePassword: "கடவுச்சொல் மறை",
    authSendReset: "மீட்டமைப்பு இணைப்பு அனுப்பு",
    authSendResetCode: "மீட்டமைப்புக் குறியீடு அனுப்பு",
    authForgotSentSms: "உங்கள் கைபேசிக்கு 6 இலக்க மீட்டமைப்புக் குறியீடு அனுப்பப்பட்டது.",
    authResetCode: "6 இலக்க மீட்டமைப்புக் குறியீடு",
    authBackLogin: "உள்நுழைவுக்குத் திரும்பு",
    authReset: "கடவுச்சொல் மீட்டமை",
    authNewPassword: "புதிய கடவுச்சொல்",
    authSavePassword: "கடவுச்சொல் சேமி",
    authInvalidReset: "இணைப்பு தவறானது அல்லது காலாவதியானது.",
    authMemberSince: "உறுப்பினர் முதல்",
    authVerify: "கணக்கைச் சரிபார்",
    authVerifyCode: "6 இலக்கக் குறியீடு",
    authVerifySubmit: "சரிபார்",
    authVerifySent: "உங்கள் மின்னஞ்சலுக்கு சரிபார்ப்புக் குறியீடு அனுப்பப்பட்டது.",
    authVerifySentSms: "உங்கள் கைபேசிக்கு 6 இலக்க OTP அனுப்பப்பட்டது.",
    authVerifySuccess: "கணக்கு சரிபார்க்கப்பட்டது! இப்போது உள்நுழையலாம்.",
    authResendCode: "குறியீட்டை மீண்டும் அனுப்பு",
    authResendBusy: "அனுப்புகிறது…",
    authVerifyTokenBusy: "இணைப்பைச் சரிபார்க்கிறது…",
    authVerifyNeedEmail: "பதிவு செய்த மின்னஞ்சலை உள்ளிடுங்கள்.",
    authVerifyNeedContact: "பதிவு செய்த மின்னஞ்சல் அல்லது கைபேசி எண்ணை உள்ளிடுங்கள்.",
    guidesTitle: "எப்படி செலுத்துவது — படிப்படியான வழிகாட்டி",
    guidesSub: (n) => `${n} அதிகாரப்பூர்வ தமிழ்நாடு கட்டண வழிகாட்டிகள்`,
    guideStepsTitle: "ஆன்லைனில் செலுத்தும் படிகள்",
    guideOfficialTitle: "அதிகாரப்பூர்வ கட்டண தளம்",
    guideOfficialBody: "IndiaFees பணம் வசூலிக்காது. அதிகாரப்பூர்வ அரசு வலைத்தளத்தை புதிய தாவலில் திறக்க கீழே கிளிக் செய்யுங்கள்.",
    guideFaqTitle: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
    guideDisclaimer: "கட்டண விவரங்கள் உள்ளிடும் முன் .gov.in அல்லது அங்கீகரிக்கப்பட்ட தளத்தில் இருக்கிறீர்களா என்பதை சரிபார்க்கவும்.",
    guideLink: "நேரடி கட்டண இணைப்பு",
    cityTitle: (name) => `${name} கட்டண இணைப்பு`,
    cityCrumb: (name) => `${name} கட்டண இணைப்பு`,
    cityBrowse: "மாநகராட்சி வாரியாக உலாவுங்கள்",
    cityBrowseSub: "முக்கிய தமிழ்நாடு மாநகராட்சிகளுக்கான அதிகாரப்பூர்வ கட்டண இணைப்புகள்",
    quickPayItems: [
      { label: "TNEB / மின்சாரம்", sharePath: "/pay/1-electricity-bill-lt-1" },
      { label: "சொத்து வரி", sharePath: "/pay/2-tn-urban-municipal-tax-3" },
      { label: "சென்னை சொத்து வரி", sharePath: "/pay/2-chennai-property-tax-2" },
      { label: "தண்ணீர்", sharePath: "/pay/2-chennai-water-tax-1" },
      { label: "அபராதம்", sharePath: "/pay/5-traffic-challan-6" },
      { label: "GST / வரி", sharePath: "/pay/4-gst-tax-payment-5" },
      { label: "நீதிமன்ற கட்டணம்", sharePath: "/pay/12-court-filing-fee-1" },
      { label: "Karuvoolam", sharePath: "/pay/15-treasury-e-challan-karuvoolam-1" },
      { label: "VAT செலுத்து", sharePath: "/pay/4-vat-e-payment-4" },
      { label: "தொழில் வரி", sharePath: "/pay/2-municipal-professional-tax-9" },
      { label: "வணிக உரிமம்", sharePath: "/pay/2-trade-license-fee-urban-10" },
      { label: "SBI Collect", sharePath: "/pay/15-treasury-payment-grips-2" },
      { label: "பரதிதாசன் பல்கலை", sharePath: "/pay/8-bharathidasan-university-fee-2" },
      { label: "சென்னை பல்கலை", sharePath: "/pay/8-madras-university-fee-3" },
      { label: "ஆவின் பால்", sharePath: "/pay/26-aavin-milk-card-renewal-1" },
      { label: "FASTag", sharePath: "/pay/20-fastag-recharge-1" },
      { label: "UGD வரி", sharePath: "/pay/2-underground-drainage-ugd-tax-11" },
      { label: "SDAT விளையாட்டு", sharePath: "/pay/27-sdat-sports-registration-1" },
    ],
  },
};

export function t(lang, key, ...args) {
  const val = UI[lang]?.[key];
  return typeof val === "function" ? val(...args) : val;
}

export function deptText(dept, lang) {
  if (lang === "ta" && DATA_TA[dept.id]) {
    const d = DATA_TA[dept.id];
    return { minister: d.minister, dept: d.dept, short: d.short };
  }
  return {
    minister: dept.minister,
    dept: dept.dept,
    short: dept.dept.replace(/^Department of /, ""),
  };
}

export function payText(payment, deptId, index, lang) {
  if (lang === "ta" && DATA_TA[deptId]?.payments?.[index]) {
    return DATA_TA[deptId].payments[index];
  }
  return { name: payment.name, desc: payment.desc };
}

/** Search across both languages */
export function paymentSearchText(payment, dept, deptId, index) {
  const en = { name: payment.name, desc: payment.desc, dept: dept.dept, minister: dept.minister };
  const ta = DATA_TA[deptId];
  const tp = ta?.payments?.[index];
  return [
    en.name, en.desc, en.dept, en.minister,
    tp?.name, tp?.desc,
    ta?.dept, ta?.short, ta?.minister,
    payment.portal,
  ].filter(Boolean).join(" ").toLowerCase();
}
